"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Loading_Loading
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_StyledLoadingBubble_js_namespaceObject = require("../../StyledLoadingBubble.js");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const ellipsisProps = {
    width: '10px',
    height: '10px',
    borderRadius: '5px',
    bg: '#868d95'
};
const LoadingWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "Loading__LoadingWrapper"
})([
    "position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1;"
]);
const Loading = ()=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(LoadingWrapper, {
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                    fontSize: 3,
                    children: " Loading "
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_StyledLoadingBubble_js_namespaceObject.StyledLoadingBox, {
                    mt: 1,
                    width: "62px",
                    height: "32px",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                            ...ellipsisProps,
                            id: "ellipses_1"
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                            ...ellipsisProps,
                            id: "ellipses_2"
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                            ...ellipsisProps,
                            id: "ellipses_3"
                        })
                    ]
                })
            ]
        })
    });
const Loading_Loading = Loading;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
